import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Player from '@vimeo/player';
import classNames from 'classnames';
import styles from './styles.css';

function VimeoEmbed({ asset, title }) {
	const ref = useRef(null);
	if (ref.current) {
		const player = new Player(ref.current);
	}

	return (
		<iframe
			allowFullScreen
			data-bounce="true"
			data-progress="true"
			data-seek="true"
			data-title={ title }
			frameBorder="0"
			ref={ ref }
			src={ `${asset.asset}&autopause=0` }
			title={ title }
		/>
	);
}

VimeoEmbed.propTypes = {
	asset: PropTypes.object.isRequired,
	title: PropTypes.string.isRequired
};

VimeoEmbed.defaultProps = {
};

function YoutubeEmbed({ asset, title }) {
	return (
		<iframe allowFullScreen data-bounce="true" data-progress="true" data-seek="true" data-title={ title } frameBorder="0" src={ `${asset.asset}&enablejsapi=1&rel=0&modestbranding=1` } title={ title }></iframe>
	);
}

YoutubeEmbed.propTypes = {
	asset: PropTypes.object.isRequired,
	title: PropTypes.string.isRequired
};

YoutubeEmbed.defaultProps = {
};

function HomepageEmbed({ asset, className, size, title }) {
	let embed;
	if (asset.asset.indexOf('vimeo.com') !== -1) {
		embed = <VimeoEmbed asset={ asset } title={ title } />;
	} else if (asset.asset.indexOf('youtube.com') !== -1) {
		embed = <YoutubeEmbed asset={ asset } title={ title } />;
	}

	return (
		<div className={ classNames(className, styles.embedContainer) }>
			<div className={ classNames(styles.embed, styles[size]) }>
				{ embed }
			</div>
		</div>
	);
}

HomepageEmbed.propTypes = {
	asset: PropTypes.object.isRequired,
	autoplay: PropTypes.bool,
	className: PropTypes.string,
	isPlaying: PropTypes.bool,
	onPause: PropTypes.func,
	onPlay: PropTypes.func,
	size: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired
};

HomepageEmbed.defaultProps = {
	autoplay: false,
	className: null,
	isPlaying: false,
	onPause: null,
	onPlay: null
};

export default HomepageEmbed;
